module.exports = __webpack_public_path__ + "media/images/red_ball-4f06685364a7e04a4f06ac850258bce8.png";